import { useEffect, useState, useCallback } from 'react';

export default function useIsMobile(breakpoint = 640){
  const [isMobile, setIsMobile] = useState(() => (
    typeof window !== 'undefined'
      ? window.matchMedia(`(max-width:${breakpoint}px)`).matches
      : false
  ));

  const get = useCallback(() => (
    typeof window !== 'undefined'
      ? window.matchMedia(`(max-width:${breakpoint}px)`).matches
      : false
  ), [breakpoint]);

  useEffect(() => {
    const mq = window.matchMedia(`(max-width:${breakpoint}px)`);
    const listener = (e) => setIsMobile(e.matches);
    const handleOrientation = () => setTimeout(() => setIsMobile(get()), 150);

    mq.addEventListener('change', listener);
    window.addEventListener('orientationchange', handleOrientation);

    return () => {
      mq.removeEventListener('change', listener);
      window.removeEventListener('orientationchange', handleOrientation);
    };
  }, [breakpoint, get]);

  return isMobile;
}